var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.338,23.09v-7.5c0-1.788-.032-4.088-2.49-4.088-2.5,0-2.878,1.947-2.878,3.959v7.63H8.182V7.667h4.6V9.775h.062a5.041,5.041,0,0,1,4.537-2.492c4.852,0,5.749,3.194,5.749,7.347V23.09Zm-17.957,0V7.667H5.175V23.089ZM0,2.778A2.779,2.779,0,1,1,2.779,5.558,2.779,2.779,0,0,1,0,2.778Z","transform":"translate(0.5 0.5)","stroke":"rgba(0,0,0,0)","strokeWidth":"1"}));
}

Linkedin.defaultProps = {"width":"24.128","height":"24.09","viewBox":"0 0 24.128 24.09"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
